import { render, staticRenderFns } from "./myprice.vue?vue&type=template&id=01e11292&scoped=true&"
import script from "./myprice.vue?vue&type=script&lang=js&"
export * from "./myprice.vue?vue&type=script&lang=js&"
import style0 from "./myprice.vue?vue&type=style&index=0&id=01e11292&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e11292",
  null
  
)

export default component.exports